import { render, staticRenderFns } from "./MallMapJs.vue?vue&type=template&id=4324e206"
import script from "./MallMapJs.vue?vue&type=script&lang=js"
export * from "./MallMapJs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports